import PropTypes from 'prop-types'
import React, { useRef, useEffect } from 'react'
import { connect } from 'react-redux'
import FormFieldLayout from 'layouts/FormFieldLayout'
import * as planActions from 'containers/stages/PlanSelectionStage/actions'

export const VOUCHER_LENGTH = 12

const VoucherCodeField = ({
  onBlur,
  onChange,
  value,
  loading,
  errorMessage,
  name,
  label,
  checkVoucher,
  onError,
  focusOnMount,
}) => {
  // Focus on mount
  const inputRef = useRef(null)
  useEffect(() => {
    if (focusOnMount) {
      inputRef.current.focus()
    }
  }, [inputRef])

  // Lookup voucher on length limit
  useEffect(() => {
    if (value.length === VOUCHER_LENGTH) {
      checkVoucher(value, err => onError({ [name]: err }))
    }
  }, [value, checkVoucher])

  const hasValueClass = value ? 'has-value' : ''
  const hasError = !!errorMessage

  const errorObject = {
    status: hasError,
    message: errorMessage,
  }
  const fieldElement = (
    <input
      ref={inputRef}
      type="text"
      name={name}
      className={`form-input ${hasValueClass}`}
      id={name}
      maxLength={`${VOUCHER_LENGTH}`}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      disabled={loading}
      required
    />
  )
  return (
    <FormFieldLayout
      fieldName={name}
      labelText={label}
      fieldElement={fieldElement}
      error={errorObject}
    />
  )
}

VoucherCodeField.defaultProps = {
  value: '',
  loading: false,
  onBlur: f => f,
  onChange: f => f,
  errorMessage: '',
  name: 'voucher',
  label: 'Enter your voucher code',
  checkVoucher: f => f,
  onError: f => f,
  focusOnMount: false,
}

VoucherCodeField.propTypes = {
  value: PropTypes.string,
  loading: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  errorMessage: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  checkVoucher: PropTypes.func,
  onError: PropTypes.func,
  focusOnMount: PropTypes.bool,
}

export default connect(state => ({
  loading: state.checkoutReducer.voucherLoading,
}), {
  checkVoucher: planActions.loadVoucher,
  onError: planActions.setFieldErrors,
})(VoucherCodeField)



// WEBPACK FOOTER //
// ./components/form/VoucherCodeField/index.jsx